export default __webpack_public_path__ + "static/media/JASPE NORINA.1ca79749.jpg";